import { FormHelperText } from "@mui/material";
import type { JSX } from "react";

export const InputError = ({ errorMsg }: { errorMsg?: string }): JSX.Element => {
  if (!errorMsg) {
    return <FormHelperText>&nbsp;</FormHelperText>;
  }

  return <FormHelperText error>{errorMsg}</FormHelperText>;
};
